import styles from '../../index.module.scss';
import type { ColumnTarget } from 'components/EmployeeCost/DirectAllocationImport/wizardReducer';
import { TARGET_LABELS } from 'components/EmployeeCost/DirectAllocationImport/directAllocationMappingHelpers';
import type { DirectAllocationChat } from '../useDirectAllocationChat';

const TARGET_OPTIONS: ColumnTarget[] = ['employee', 'percent', 'customer', 'class', 'skip'];

export default function MappingCard({ chat }: { chat: DirectAllocationChat }) {
	const { session, dispatch } = chat;

	return (
		<div className={styles['action-card']}>
			<div className={styles['action-card__summary']}>
				Map each column to Employee, % of Hours, Customer, or Class.
			</div>
			<div className={styles['import-table-wrap']}>
				<table className={styles['import-table']}>
					<thead>
						<tr>
							<th>File Column</th>
							<th>Sample</th>
							<th>Map To Field</th>
						</tr>
					</thead>
					<tbody>
						{session.columnMappings.map((m) => (
							<tr key={m.colIndex}>
								<td>
									<strong>{m.sourceHeader}</strong>
								</td>
								<td>{m.sampleValues.slice(0, 2).join(', ')}</td>
								<td>
									<select
										value={m.target}
										onChange={(e) =>
											dispatch({
												type: 'COLUMN_TARGET_CHANGED',
												colIndex: m.colIndex,
												target: e.target.value as ColumnTarget,
											})
										}
									>
										{TARGET_OPTIONS.map((t) => (
											<option key={t} value={t}>
												{TARGET_LABELS[t]}
											</option>
										))}
									</select>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			{!chat.canAdvanceFromMapping && (
				<div className={styles['action-card__status']}>
					Map at least one column to Employee and one to % of Hours to continue.
				</div>
			)}

			<div className={styles['smart-import-card__buttons-wrap']}>
				<button
					type="button"
					className={styles['action-card__confirm']}
					disabled={!chat.canAdvanceFromMapping || chat.loading}
					onClick={() => void chat.continueFromMapping()}
				>
					{chat.loading ? 'Loading…' : 'Continue'}
				</button>
			</div>
		</div>
	);
}
